import { FC } from 'react';
import type { File } from '@teachur/http-client';

interface StudentIdDocumentsProps {
  idImage1?: File;
  idImage2?: File;
}

export const StudentIdDocuments: FC<StudentIdDocumentsProps> = ({ idImage1, idImage2 }) => {
  if (!idImage1?.url && !idImage2?.url) return null;

  return (
    <div className="flex flex-col gap-2">
      <p className="[font-size:var(--fs-l4)]! font-semibold text-(--neutral-white-NW200)! m-0!">
        Student ID Documents
      </p>
      <div className="flex gap-2">
        {idImage1?.url && (
          <div className="flex flex-col gap-1 flex-1">
            <p className="[font-size:var(--fs-l5)]! text-(--neutral-white-NW400)! m-0!">
              Primary ID
            </p>
            <a href={idImage1.url} target="_blank" rel="noreferrer">
              <img
                src={idImage1.url}
                alt="Primary ID"
                className="w-full h-28 object-cover rounded-md! border border-(--neutral-white-NW700)"
              />
            </a>
          </div>
        )}
        {idImage2?.url && (
          <div className="flex flex-col gap-1 flex-1">
            <p className="[font-size:var(--fs-l5)]! text-(--neutral-white-NW400)! m-0!">
              Secondary ID
            </p>
            <a href={idImage2.url} target="_blank" rel="noreferrer">
              <img
                src={idImage2.url}
                alt="Secondary ID"
                className="w-full h-28 object-cover rounded-md! border border-(--neutral-white-NW700)"
              />
            </a>
          </div>
        )}
      </div>
    </div>
  );
};
